<div class="row">
  <ion-icon src="assets/icons/green-circle-tick.svg" />
  <span>{{label()}}</span>
</div>